import React from "react";
import "../landing.css";
import styled from "styled-components";
import sendEmail from "../../../asset/ces/btn_sendmessage=Default.png";
import sendEmailHover from "../../../asset/ces/btn_sendmessage=hover.png";
import sendEmailActive from "../../../asset/ces/btn_sendmessage=pressed.png";

const IconButton = styled.img`
  cursor: pointer;

  &[src="${sendEmail}"] {
    content: url(${sendEmail});
    &:hover {
      content: url(${sendEmailHover});
    }
    &:active {
      content: url(${sendEmailActive});
    }
  }
`;

const ContactUs = () => {
  React.useEffect(() => {
    // 모든 이미지 프리로드
    const images = [sendEmail, sendEmailHover, sendEmailActive];

    images.forEach((src) => {
      const img = new Image();
      img.src = src;
    });
  }, []);

  return (
    <div className="landing-section-sns">
      <h1 className="landing-section-title">Contact Us</h1>
      <div className="sns-container">
        <IconButton
          src={sendEmail}
          alt="send email"
          onClick={() =>
            (window.location.href =
              "mailto:hkshin0716@mindsai.co.kr?cc=ahyunia@mindsai.co.kr")
          }
        />
      </div>
    </div>
  );
};

export default ContactUs;
